import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the alert api
 */
export class AlertService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getAlerts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/alerts' + params);		
		return data;
	}
	
	async activateAlert(alertId) {	
		var result = await this.makePUTRequest('/api/resource/alerts/' + alertId + '/activate');
		return result;
	}	

	async inactivateAlert(alertId) {	
		var result = await this.makePUTRequest('/api/resource/alerts/' + alertId + '/inactivate');
		return result;
	}
	
	async saveAlert(userAlert, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/alerts/' + userAlert.alertId, userAlert);
		} else {
			saved = await this.makePOSTRequest('/api/resource/alerts', userAlert);
		}
		return saved;
	}

	async deleteAlert(alertId) {		
		var result = await this.makeDELETERequest('/api/resource/alerts/' + alertId);		
		return result;
	}	
	
};

